import React, { useCallback } from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';
import { IconPin } from '../../../base/icons/svg';
import ContextMenuItem from '../../../base/ui/components/web/ContextMenuItem';
import { getLocalParticipant } from '../../../base/participants/functions';
import { PARTICIPANT_ROLE } from '../../../base/participants/constants';
import { forcePinParticipant } from '../../../base/participants/actions';
import { NOTIFY_CLICK_MODE } from '../../../toolbox/types';
const ForcePinButton = ({ className, noIcon = false, notifyClick, notifyMode, onClick, participantID }) => {
    const dispatch = useDispatch();
    const { t } = useTranslation();
    const localParticipant = useSelector(getLocalParticipant);
    // Only show this button to moderators
    const isModerator = localParticipant?.role === PARTICIPANT_ROLE.MODERATOR;
    if (!isModerator) {
        return React.createElement(React.Fragment, null);
    }
    const _onClick = useCallback(() => {
        notifyClick?.();
        if (notifyMode === NOTIFY_CLICK_MODE.PREVENT_AND_NOTIFY) {
            return;
        }
        // Dispatch the force pin action
        dispatch(forcePinParticipant(participantID));
        onClick?.();
    }, [dispatch, notifyClick, onClick, participantID]);
    const text = t('videothumbnail.forcePinForEveryone');
    const icon = IconPin;
    return (React.createElement(ContextMenuItem, { accessibilityLabel: text, icon: noIcon ? null : icon, onClick: _onClick, text: text, textClassName: className }));
};
export default ForcePinButton;
